export const API_URL = "https://vaaradhi-dev.agrani.tech";
